import "core-js";
import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import { withStyles } from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import { MenuItem } from "@material-ui/core";

import suggestions from "../../../constants/countries";

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot
        },
        ...InputProps
      }}
      {...other}
    />
  );
}

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem
}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || "").indexOf(suggestion.name) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={suggestion.alpha2Code}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400
      }}
    >
      {suggestion.name}
    </MenuItem>
  );
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  suggestion: PropTypes.shape({ name: PropTypes.string }).isRequired
};

function getSuggestions(inputValue) {
  let count = 0;

  return suggestions.filter(suggestion => {
    const keep =
      (!inputValue ||
        suggestion.name.toLowerCase().indexOf(inputValue.toLowerCase()) !==
          -1) &&
      count < 5;

    if (keep) {
      count += 1;
    }

    return keep;
  });
}

const styles = theme => ({
  root: {
    flexGrow: 1
    //height: 250
  },
  container: {
    flexGrow: 1,
    position: "relative"
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  chip: {
    margin: `${theme.spacing(2)}px ${theme.spacing(4)}px`
  },
  inputRoot: {
    flexWrap: "wrap"
  }
});

const lookUpCode = CountryName => {
  return suggestions
    .filter(
      ({ name, alpha2Code }) => name.toLowerCase() === CountryName.toLowerCase()
    )
    .find(result => (result === undefined ? undefined : result.alpha2Code));
};

// const lookUpName = (CountryCode) => {
//   return suggestions.filter(({name,alpha2Code}) => alpha2Code===CountryCode).find(result => (result === undefined?undefined:result.name));
// }

class SelectCountry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
  }
  handleChange(selectedItem, stateAndHelpers) {
    const code = lookUpCode(selectedItem);
    this.props.setFieldValue(this.props.name, code);
  }

  onStateChange(changes, stateAndHelpers) {
    if (
      changes.type === "__autocomplete_change_input__" &&
      stateAndHelpers.inputValue.length > 3
    ) {
      const item = lookUpCode(stateAndHelpers.inputValue);
      if (item) {
        this.setState({ item: item });
      }
    }
    if (
      changes.type === "__autocomplete_blur_input__" &&
      this.state.item &&
      this.state.item.hasOwnProperty("name")
    ) {
      stateAndHelpers.selectItem(this.state.item.name);
      this.props.setFieldValue(this.props.name, this.state.item);
    }
  }

  render() {
    const { props } = this;

    const { classes } = props;
    const defaultSelectedItem = this.props.value.hasOwnProperty("name")
      ? this.props.value.name
      : "";

    return (
      <div className={classes.root}>
        <Downshift
          defaultSelectedItem={defaultSelectedItem}
          defaultInputValue={defaultSelectedItem}
          onChange={this.handleChange}
          onStateChange={this.onStateChange}
        >
          {({
            getInputProps,
            getItemProps,
            isOpen,
            inputValue,
            selectedItem,
            highlightedIndex
          }) => (
            <div className={classes.container}>
              {renderInput({
                fullWidth: true,
                classes,
                className: this.props.className,
                label: this.props.label,
                required: this.props.required,
                error: this.props.error,
                helperText: this.props.helperText,
                InputProps: getInputProps({
                  //placeholder: "Search a country (start with a)",
                  id: "selectcountry-" + this.props.name,
                  name: this.props.name
                })
              })}
              {isOpen ? (
                <Paper className={classes.paper} square>
                  {getSuggestions(inputValue).map((suggestion, index) =>
                    renderSuggestion({
                      suggestion,
                      index,
                      itemProps: getItemProps({ item: suggestion.name }),
                      highlightedIndex,
                      selectedItem
                    })
                  )}
                </Paper>
              ) : null}
            </div>
          )}
        </Downshift>
      </div>
    );
  }
}

SelectCountry.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SelectCountry);
